import vm from '@journeys/Journeys.viewmodel';
import { DirectiveBinding, VNode } from 'vue';

const { editor } = vm;

// custom markup events
export const vWhen: any = {
    mounted(el: HTMLElement, { arg, value, modifiers }: DirectiveBinding, vnode: VNode | any): void {
        editor.events.addListener(arg!, (...payload: Array<unknown>) => value(...payload, el, vnode));
    },
    beforeUnmount(el: HTMLElement, { arg }: DirectiveBinding) {
        editor.events.removeListener(arg!);
    },
};
